/*************************************************/
/* Vue                                           */
/*************************************************/
import { createApp, h } from 'vue';
import PrimeVue from 'primevue/config';
import OrderVehicleFlow from './vue/orderVehicleFlow.vue';
import ContactVehicleFlow from './vue/contactVehicleFlow.vue';
import TestdriveVehicleFlow from './vue/testdriveVehicleFlow.vue';
import FinanceVehicleFlow from './vue/financeVehicleFlow.vue';
import ContentModal from './vue/contentModal.vue';
import ToastService from 'primevue/toastservice';
import PrimevueLocale from './vue/primevueLocale';
import Recaptcha from './partials/recaptcha';
import { Fancybox } from "@fancyapps/ui";
import DialogService from 'primevue/dialogservice';
import CustomEventsNames from './customEventsNames.js';

const modelElement = document.querySelector('#vehicleModel');

//Initialize Recaptcha
const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}
ready(() => {
    Recaptcha.Init();



    Fancybox.bind('[data-fancybox="vehicle-images"]', {
        hideScrollbar: false,
        Thumbs: {
            type: "classic",
        },
    });

    const setVehicleNavigationState = function () {
        const vehicleNavigationItems = document.querySelectorAll('.vehicle-navigation__item');
        if (vehicleNavigationItems && location.hash) {
            vehicleNavigationItems.forEach(item => {
                if (item.querySelector('a[href="' + location.hash + '"]')) {
                    item.classList.add('vehicle-navigation__item--active')
                } else {
                    item.classList.remove('vehicle-navigation__item--active')
                }
            })
        }
    }

    window.addEventListener('hashchange', e => {
        setVehicleNavigationState();
    })
    setVehicleNavigationState();

    const vehicleNavigationLinks = document.querySelectorAll('.vehicle-navigation__item > a');
    if (vehicleNavigationLinks) {
        vehicleNavigationLinks.forEach(link => {
            link.addEventListener('click', e => {
                e.preventDefault();
                const target = document.querySelector(link.hash);
                window.scrollTo({top:target.offsetTop,left:0,behavior:'smooth'});
                history.replaceState(null,null,link.hash);
                window.dispatchEvent(new HashChangeEvent("hashchange"));
            });
        })
    }
});

const orderVehicleFlowSelector = '#orderVehicleFlow';
const orderVehicleFlowElement = document.querySelector(orderVehicleFlowSelector);
if (orderVehicleFlowElement) {
    const vehicle = modelElement.dataset.vehicle;
    const nodeId = modelElement.dataset.nodeId;
    const branchesNodeId = modelElement.dataset.branchesNodeId;

    const seedData = {
        vehicle: vehicle,
        nodeId: nodeId,
        branchesNodeId: branchesNodeId
    };

    const orderVehicleFlow = createApp({
        data() { return seedData },
        render: () => h(OrderVehicleFlow)
    }, seedData);

    orderVehicleFlow.use(DialogService);
    orderVehicleFlow.use(PrimeVue, {
        locale: PrimevueLocale.locale
    });
    orderVehicleFlow.use(ToastService);
    orderVehicleFlow.mount(orderVehicleFlowElement);
}

const contactVehicleFlowSelector = '#contactVehicleFlow';
const contactVehicleFlowElement = document.querySelector(contactVehicleFlowSelector);
if (contactVehicleFlowElement) {
    const vehicle = modelElement.dataset.vehicle;
    const nodeId = modelElement.dataset.nodeId;
    const branchesNodeId = modelElement.dataset.branchesNodeId;
    const branchNodeId = modelElement.dataset.branchNodeId;
    const seedData = {
        vehicle: vehicle,
        nodeId: nodeId,
        branchesNodeId: branchesNodeId,
        branchNodeId: branchNodeId
    };

    const contactVehicleFlow = createApp({
        data() { return seedData },
        render: () => h(ContactVehicleFlow)
    }, seedData);

    contactVehicleFlow.use(DialogService);
    contactVehicleFlow.use(PrimeVue, {
        locale: PrimevueLocale.locale
    });
    contactVehicleFlow.use(ToastService);
    contactVehicleFlow.mount(contactVehicleFlowElement);
}

const testdriveVehicleFlowSelector = '#testdriveVehicleFlow';
const testdriveVehicleFlowElement = document.querySelector(testdriveVehicleFlowSelector);
if (testdriveVehicleFlowElement) {
    const vehicle = modelElement.dataset.vehicle;
    const nodeId = modelElement.dataset.nodeId;
    const branchesNodeId = modelElement.dataset.branchesNodeId;
    const seedData = {
        vehicle: vehicle,
        nodeId: nodeId,
        branchesNodeId: branchesNodeId
    };

    const testdriveVehicleFlow = createApp({
        data() { return seedData },
        render: () => h(TestdriveVehicleFlow)
    }, seedData);

    testdriveVehicleFlow.use(DialogService);
    testdriveVehicleFlow.use(PrimeVue, {
        locale: PrimevueLocale.locale
    });
    testdriveVehicleFlow.use(ToastService);
    testdriveVehicleFlow.mount(testdriveVehicleFlowElement);
}

const financeVehicleFlowSelector = '#financeVehicleFlow';
const financeVehicleFlowElement = document.querySelector(financeVehicleFlowSelector);
if (financeVehicleFlowElement) {
    const vehicle = modelElement.dataset.vehicle;
    const nodeId = modelElement.dataset.nodeId;
    const branchesNodeId = modelElement.dataset.branchesNodeId;
    const seedData = {
        vehicle: vehicle,
        nodeId: nodeId,
        branchesNodeId: branchesNodeId
    };

    const financeVehicleFlow = createApp({
        data() { return seedData },
        render: () => h(FinanceVehicleFlow)
    }, seedData);

    financeVehicleFlow.use(DialogService);
    financeVehicleFlow.use(PrimeVue, {
        locale: PrimevueLocale.locale
    });
    financeVehicleFlow.use(ToastService);
    financeVehicleFlow.mount(financeVehicleFlowElement);
}

const vehicleContentModalSelector = '#vehicleContentModal';
const vehicleContentModalElement = document.querySelector(vehicleContentModalSelector);
if (vehicleContentModalElement) {
    const vehicleContentModal = createApp({
        render: () => h(ContentModal)
    });

    vehicleContentModal.use(PrimeVue, {
        locale: PrimevueLocale.locale
    });
    vehicleContentModal.mount(vehicleContentModalElement);

    const vehicleModalsTriggers = document.querySelectorAll('.vehicle-modal-trigger');
    if (vehicleModalsTriggers) {
        vehicleModalsTriggers.forEach(trigger => {
            trigger.addEventListener('click', e => {
                const openContentModalEvent = new CustomEvent(CustomEventsNames.openContentModal, {
                    detail: {
                        header: trigger.dataset.header,
                        content: trigger.dataset.content
                    }
                });

                document.getElementById('contentModal').dispatchEvent(openContentModalEvent);
            });
        })
    }
}
